import type { GeolocationState, GeolocationAction } from './geolocation.types';
import { GEOLOCATION_ACTION } from '$constants/enums';

export const geolocationReducer = (
  state: GeolocationState,
  action: GeolocationAction
): GeolocationState => {
  switch (action.type) {
    case GEOLOCATION_ACTION.SET_GEOLOCATION_LOADING:
      return {
        ...state,
        error: action.payload ? null : state.error
      };

    case GEOLOCATION_ACTION.SET_GEOLOCATION_POSITION:
      return {
        ...state,
        position: action.payload,
        error: null,
        lastUpdated: new Date(),
        permissionStatus: 'granted'
      };

    case GEOLOCATION_ACTION.SET_GEOLOCATION_ERROR:
      return {
        ...state,
        error: action.payload,
        position: null
      };

    case GEOLOCATION_ACTION.SET_GEOLOCATION_PERMISSION:
      return {
        ...state,
        permissionStatus: action.payload
      };

    case GEOLOCATION_ACTION.CLEAR_GEOLOCATION_ERROR:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
};
